module.exports = __webpack_public_path__ + "static/media/halfImage.7f529a6b.psd";